import { User } from "firebase/auth"
import { create } from "zustand"

interface UserState {
    user: User | null
    setuser: (user: User | null) => void
}
export const useUserStore = create<UserState>((set) => ({
    user: null,
    setuser: (user) => set({user: user})
}));

export const userUserStore = useUserStore;